import request from '@/utils/axios';

//  生产任务列表 - 排期
export function listProductionTask(data) {
  return request({
    url: '/h5/project-bundle/listProductionTask',
    method: 'post',
    data,
  });
}

//  生产任务列表 - 自由
export function listProductionTaskFree(data) {
  return request({
    url: '/h5/project-bundle/listProductionTaskByFreeDom',
    method: 'post',
    data,
  });
}

//  生产订单列表
export function listProductionOrder(data) {
  return request({
    url: '/h5/project-bundle/listProductionOrder',
    method: 'post',
    data,
  });
}

// 【生产单管理-订单排期】列表的所有【进行中】状态的订单
export function orderPageList(data) {
  return request({
    url: '/h5/project/order/page',
    method: 'post',
    data,
  });
}

// 【制造管理-款号管理】款号列表中的所有款号
export function stylePageList(data) {
  return request({
    url: '/h5/style/page',
    method: 'post',
    data,
  });
}

// 【系统管理-用户管理】列表的所有用户
export function humanPageList(data) {
  return request({
    url: '/h5/human/page',
    method: 'post',
    data,
  });
}

// 管理员类型用户
export function userPageList(data) {
  return request({
    url: '/h5/common/user/page',
    method: 'post',
    data,
  });
}

// 【制造管理-工序管理】列表的所有工序
export function processPageList(data) {
  return request({
    url: '/h5/process/page',
    method: 'post',
    data,
  });
}

// 扎号信息接口 - 获取某个生产单下的扎号列表
export function projectBundlePage(data) {
  return request({
    url: '/h5/project-bundle/page',
    method: 'post',
    data,
  });
}

// 入菲数据列表
export function bundleRecordPage(data) {
  return request({
    url: '/h5/project-bundle/item-record/page',
    method: 'post',
    data,
  });
}

// 正在进行的任务
export function unfinishedTask() {
  return request({
    url: '/h5/project-bundle/unfinishedTask',
    method: 'post',
  });
}

// 扎号对应工序的排产日期
export function dateList(data) {
  return request({
    url: '/h5/project-bundle/dateList',
    method: 'post',
    data,
  });
}

// 员工胜任的工序
export function usersProcess(data) {
  return request({
    url: '/h5/process/my',
    method: 'post',
    data,
  });
}

// 待复核数量
export function pendingReviewNum() {
  return request({
    url: '/h5/project-bundle/item-record/pendingReviewNum',
    method: 'get',
  });
}

// 待审核数量
export function pendingAuthCount(data) {
  return request({
    url: '/h5/project-bundle-scan-auth/pendingAuthCount',
    method: 'post',
    data,
  });
}

// 当前用户是否被暂停扫码 - 暂停信息
export function currentPause() {
  return request({
    url: '/h5/project-bundle-scan-auth/currentPause',
    method: 'get',
  });
}

// 获取某工序下胜任员工
export function processEmpList(processId) {
  return request({
    url: '/h5/processEmpList/' + processId,
    method: 'get',
  });
}
